export default ({ typeName }) => ({
  options: {
    private: `Only ${typeName} Owners and users who have been assigned this ${typeName} can view it.`,
    public: `Anyone can view this ${typeName} using this link:`,
  },
});
